module.exports = __webpack_public_path__ + "img/businessScenario.5f86ff2f.jpg";